<template>
  <div>
    <!-- 교육별 대상자 목록 -->
    <c-table
      ref="table"
      title="LBL0002862"
      tableId="table"
      :columns="grid.columns"
      gridHeight="800px"
      :data="grid.data"
      :editable="false"
      :filtering="false"
      :checkClickFlag="false"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <!-- 대상자 연명부 -->
            <c-btn v-show="grid.data.length>0 && editable" label="LBL0002863" icon="print" @btnClicked="btnPrint" />
            <!-- <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" /> -->
          </q-btn-group>
        </div>
      </template>
      
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'click'">
            <q-btn 
              round unelevated 
              size="10px"
              color="amber" 
              icon="search"
              @click.stop="() => { rowIndex = props.rowIndex, electronSignature = props.row.electronSignature}"
              >
              <q-popup-proxy :ref="'proxy' + props.rowIndex" :breakpoint="400">
                <component
                  :is="col.component"
                  :popupParam="props.row"
                  :rowIndex="props.rowIndex"
                  @callback="callback"
                />
              </q-popup-proxy>
            </q-btn>
          </template>
        </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "education-target-users-pop",
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          plantCd: '',
          eduCourseId: '',
          startYmd: '',
          endYmd: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "educationName",
            field: "educationName",
            // 교육명
            label: "LBL0002929",
            align: "left",
            sortable: true,
          },
          {
            name: "educationDate",
            field: "educationDate",
            // 교육기간
            label: "LBL0002829",
            style: 'width:180px',
            align: "center",
            sortable: true,
          },
          {
            name: 'attendeesDeptName',
            field: 'attendeesDeptName',
            style: 'width:140px',
            // 부서
            label: 'LBLDEPT',
            align: 'center',
            sortable: false,
          },
          {
            name: 'attendeesName',
            field: 'attendeesName',
            // 대상자
            label: 'LBL0002864',
            style: 'width:100px',
            align: 'center',
            sortable: false
          },
          {
            name: 'click',
            field: 'click',
            // 서명보기
            label: 'LBL0002865',
            style: 'width:70px',
            type: 'custom',
            align: 'center',
            sortable: false,
            component: () => import(`${'@/pages/sop/edu/result/signaturePop.vue'}`)
          },
          {
            name: 'evaluationPoint',
            field: 'evaluationPoint',
            // 평가점수
            label: 'LBL0002866',
            style: 'width:100px',
            align: 'center',
            sortable: false
          },
          {
            name: 'evaluationContent',
            field: 'evaluationContent',
            // 평가내용
            label: 'LBL0002867',
            style: 'width:220px',
            align: 'center',
            sortable: false
          },
          {
            name: 'evaluationDate',
            field: 'evaluationDate',
            setHeader: true,
            // 이수일
            label: 'LBL0002868',
            style: 'width:110px',
            align: 'center',
            sortable: false
          },
          {
            name: 'noAttendanceReason',
            field: 'noAttendanceReason',
            // 불참사유
            label: 'LBL0002869',
            style: 'width:200px',
            align: 'left',
            sortable: false
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        startYmd: '',
        endYmd: '',
        educationCourseName: '',
        eduCourseId: '',
      },
      period: [],
      editable: true,
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      listUrl: "",
      printUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      
      if (this.popupParam.plantCd) {
        this.$set(this.searchParam, 'plantCd', this.popupParam.plantCd)
      }
      if (this.popupParam.eduCourseId) {
        this.$set(this.searchParam, 'eduCourseId', this.popupParam.eduCourseId)
      }
      if (this.popupParam.startYmd) {
        this.$set(this.searchParam, 'startYmd', this.popupParam.startYmd)
      }
      if (this.popupParam.endYmd) {
        this.$set(this.searchParam, 'endYmd', this.popupParam.endYmd)
      }
      // url setting
      this.listUrl = selectConfig.sop.edu.target.users.url;
      this.printUrl = selectConfig.sop.edu.result.print.courseByTargetUser.url;
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    btnPrint() {
      if (!this.searchParam.eduCourseId) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSG0000861', // 검색조건에서 교육과정을 선택하세요.
          type: 'warning', // success / info / warning / error
        });
        return;
      } 
      let thisVue = this;
      this.$http.url = this.printUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request(
        _result => {
          let fileOrgNm = this.grid.data[0].educationCourseName + ' 연명부.docx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        }, () => { }
      );
    },
    callback(data, rowIndex) {
      let refName = 'proxy' + rowIndex;
      this.$refs[refName].hide();
    },
  },
};
</script>
